export default __webpack_public_path__ + "static/media/misc-books1-1440w.cac38383.webp";